import { render, staticRenderFns } from "./BeefPolicyModal.vue?vue&type=template&id=bb84d1b6"
import script from "./BeefPolicyModal.vue?vue&type=script&lang=js"
export * from "./BeefPolicyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports